// huoqu shuju
const getters = {
  axios_message: (state) => state.app.axios_message
}

export default getters
